import Card from '@salesforce/design-system-react/components/card';
import ProjectsHome from '../Project/ProjectsHome';

const Home = () => {
  // const [contacts, setContacts] = useState<FactoryGenericApiV1Contact[]>([]);
  // const contactsQuery = useContactServiceListContactsQuery({});

  // useEffect(() => {
  //   if (contactsQuery.data?.contacts !== undefined) {
  //     setContacts(contactsQuery.data?.contacts);
  //   }
  // }, [contactsQuery.isLoading, contactsQuery.isFetching]);
  return (
    <div
      className="slds-grid slds-grid_vertical flex-grow-1 align-items-stretch slds-template_bottom-magnet"
      // style={{ height: 'calc(100vh - 50px)', marginBottom: '50px' }}
      style={{ height: 'calc(100vh)' }}
    >
      <Card
        id="HomeCard"
        hasNoHeader
        heading=""
        className="flex-grow-1 slds-grid_vertical slds-grid  min-height-0"
        bodyClassName="slds-grid slds-grid_vertical slds-m-bottom_none custom-scroll-overflow"
        style={{
          borderBottom: 'none',
          borderRadius: '0.25rem 0.25rem 0 0'
        }}
      >
        <ProjectsHome />
      </Card>
    </div>
  );
};

export default Home;
